import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DragNdrop from "../../../Components/DragNdropFile";
import Editor from "../../../Components/Editor";
import PageHeader from "../../../Components/PageHeader";
import Spin from "../../../Components/Spin";
import api from "../../../Utils/api";

const NewApplication = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [images, setImages] = useState([]);
  const [application, setApplication] = useState([]);
  const [description, setDescription] = useState("");
  const [appData, setAppData] = useState({
    label: "",
    actif: "",
  });

  useEffect(() => {
    document.title = "DashBoard | Nouvel Application";
  }, []);

  // console.log(description);

  const formatAcceptedFiles = (file, format) => {
    let flag = false;

    for (const item of file) {
      const fileParts = item.name.split(".");
      const extension = fileParts[fileParts.length - 1];

      if (format.includes(extension)) {
        flag = true;
      }
    }

    return flag;
  };

  const handleFileChange = (event) => {
    event.preventDefault();
    const app = event.target.files;

    if (!app && app.length <= 0) {
      return;
    }

    const logiciel = Array.from(app);
    const accepted = formatAcceptedFiles(logiciel, ["exe"]);
    if (!accepted) {
      return;
    }
    setApplication(logiciel);
    console.log(logiciel);
  };

  const handleChange = ({ target }) => {
    const { name, value } = target;
    setAppData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);

    const dataApp = {
      labelle: appData.label,
      description: description,
      actif: appData.actif,
      lien: application,
      image: images,
    };

    if (
      dataApp.labelle === "" ||
      dataApp.description === "" ||
      dataApp.actif === "" ||
      dataApp.lien.length <= 0 ||
      dataApp.image.length <= 0
    ) {
      toast.warning("Vous devez remplir tous les champs!");
      return;
    }

    try {
      const { data } = await api.post("application", dataApp, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (!data.application) {
        toast.error("Vérifier vos données avant la soumission.");
        return;
      }

      toast.success("Application ajoutée avec succès.");
      navigate("/applications");
    } catch (error) {
      if (error.response.status === 401) {
        navigate("/login");
      }
      if (error.response.status === 404) {
        toast.warning(error.response.Message);
        return;
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <PageHeader page="Nouvel Application" />

      {/* Main content */}
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header"></div>
            <div className="card-body">
              <form
                className="form-horizontal"
                encType="multipart/form-data"
                onSubmit={handleSubmit}
              >
                <div className="form-group row">
                  <label htmlFor="label" className="col-sm-2 col-form-label">
                    Libéllé
                  </label>
                  <div className="col-sm-10">
                    <input
                      type="text"
                      className="form-control"
                      id="label"
                      name="label"
                      placeholder="Libéllé"
                      required
                      value={appData.label}
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label htmlFor="desc" className="col-sm-2 col-form-label">
                    Description
                  </label>
                  <div className="col-sm-10">
                    <Editor value={description} onChange={setDescription} />
                  </div>
                </div>
                <div className="form-group row">
                  <label htmlFor="actif" className="col-sm-2 col-form-label">
                    Status
                  </label>
                  <div className="col-sm-10">
                    <select
                      className="custom-select form-control-border"
                      id="actif"
                      name="actif"
                      required
                      value={appData.actif}
                      onChange={(e) => handleChange(e)}
                    >
                      <option value="">Choisir un status</option>
                      <option value={true}>Activé</option>
                      <option value={false}>Désactivé</option>
                    </select>
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    // htmlFor="application"
                    className="col-sm-2 col-form-label"
                  >
                    Exécutable de l'application
                  </label>
                  <div className="col-sm-10">
                    {/* <input
                      type="file"
                      name="application"
                      id="application"
                      className="form-control"
                      onChange={handleFileChange}
                      accept=".exe"
                      required
                      // accept=".pdf,.docx,.pptx,.txt,.xlsx"
                    /> */}
                    <div className="custom-file">
                      <input
                        type="file"
                        className="custom-file-input"
                        name="application"
                        id="application"
                        onChange={handleFileChange}
                        accept=".exe"
                        required
                        style={{ cursor: "pointer" }}
                      />
                      <label
                        className="custom-file-label"
                        htmlFor="application"
                      >
                        Choisir l'executable de l'applicatif
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <label htmlFor="img" className="col-sm-2 col-form-label">
                    Image
                  </label>
                  <div className="col-sm-10">
                    <DragNdrop
                      onFilesSelected={setImages}
                      multiple={true}
                      // required={true}
                      // formatAccepted={".png"}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="offset-sm-2 col-sm-10">
                    <button
                      type="submit"
                      className="btn btn-info"
                      disabled={isLoading}
                    >
                      {isLoading ? <Spin size="sm" /> : "Ajouter"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      {/* /.content */}
    </>
  );
};

export default NewApplication;
